var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeaconCircleOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "World Vision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ff6b00",
    cx: 42.916,
    cy: 42.916,
    r: 42.673
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.972 84.13c1.57-23.382 1.374-38.354 5.383-42.055 4.01-3.701 11.103-3.617 22.458-4.458-25.906-1.907-26.13-2.327-27.841-27.337-1.682 25.01-1.935 25.43-27.841 27.337 11.355.84 18.757 1.01 22.458 4.458 3.7 3.448 3.785 18.673 5.383 42.056z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaconCircleOrange);
export default __webpack_public_path__ + "static/media/beacon-circle-orange.80a61ef620ca7b78c7d10cfddf42679b.svg";
export { ForwardRef as ReactComponent };